import { useRef } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

//UI
import { Box, Button, Checkbox, Flex, Spacer, Text } from '@chakra-ui/react'
import { MdDragHandle } from 'react-icons/md'
import { IoIosRemoveCircleOutline } from 'react-icons/io'
import { RemoveButton } from '@/components/Elements/Button'

const ColumnMenuItem = ({ id, canRemove, handleRemoveColumn, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Flex ref={setNodeRef} style={style} my={1} alignItems={'center'} gap="2">
      <Box color="gray.400" {...attributes} {...listeners} _hover={{ cursor: 'grab' }}>
        <MdDragHandle size={25} />
      </Box>
      <Text>{children}</Text>
      <Spacer></Spacer>
      {canRemove && <RemoveButton onClick={handleRemoveColumn} />}
    </Flex>
  )
}

export default ColumnMenuItem
